import axios from "axios";
import {NAVBAR_LINKS_API_URL} from "./URL";

export const getNavbar = async () => {
    const params = {};
    params[`populate[0]`] = 'links.links';
    return axios.get(NAVBAR_LINKS_API_URL, {
        params: params
    })
}